var map = {
	"./account/Account.vue": "3d18",
	"./admin/Admin.vue": "546f",
	"./dataprivacy/Dataprivacy.vue": "c6e6",
	"./error/Error.vue": "e839",
	"./home/Home.vue": "5c28",
	"./imprint/Imprint.vue": "bc16",
	"./language/Language.vue": "2c1d",
	"./learn/Learn.vue": "6572",
	"./login/Login.vue": "4b3f",
	"./my_vocabulary/MyVocabulary.vue": "1a49",
	"./passwordreset/PasswordReset.vue": "4059",
	"./quiz/Quiz.vue": "ec90",
	"./settings/Settings.vue": "65be",
	"./signup/SignUp.vue": "607b",
	"./vocabulary/Vocabulary.vue": "40b3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b3ad";